import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWardrobe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWardrobe"><Path d="M4.5 2.5H19.5V19.5H4.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 19.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 19.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 3V19" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 10V12" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 10V12" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWardrobe;
